import React from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, Copy } from "lucide-react";
import { useState } from "react";

export default function OrderSuccess() {
  const { orderNumber } = useParams();
  const [copied, setCopied] = useState(false);
  const copy = () => { navigator.clipboard.writeText(orderNumber); setCopied(true); setTimeout(() => setCopied(false), 1500); };
  return (
    <div className="pt-28 pb-16 max-w-xl mx-auto px-4 text-center" data-testid="order-success-page">
      <div className="mx-auto w-20 h-20 rounded-full bg-amber-500/10 border border-amber-500/40 grid place-items-center">
        <CheckCircle2 size={44} className="text-amber-300" />
      </div>
      <h1 className="font-serif text-4xl text-white mt-6">Order placed!</h1>
      <p className="text-zinc-400 mt-2">We've received your order and will verify it shortly.</p>
      <div className="card-lux mt-6 p-5">
        <div className="text-xs text-zinc-500 font-mono tracking-widest uppercase">Order Number</div>
        <div className="mt-1 flex items-center justify-center gap-2">
          <span data-testid="order-number" className="font-mono text-2xl text-amber-200">{orderNumber}</span>
          <button onClick={copy} className="text-zinc-400 hover:text-white"><Copy size={16} /></button>
        </div>
        {copied && <div className="text-xs text-amber-300 mt-1">Copied</div>}
      </div>
      <div className="mt-6 flex gap-2 justify-center">
        <Link to={`/track?o=${orderNumber}`} data-testid="go-track-btn" className="btn-gold">Track order</Link>
        <Link to="/menu" className="btn-outline-gold">Order more</Link>
      </div>
    </div>
  );
}
